<template>
  <v-card class="card pa-4  mt-4" color="gray10" flat>
    <div class="d-flex title">
      <v-icon>$editList</v-icon>
      <h2 class="font-Light-16 ms-2 ">
        {{ $t("corporateAccount.manage.legalAccountsList") }}
      </h2>
    </div>

    <div class="py-4">
      <p class="gray3--text font-Regular-16">
        {{ $t("corporateAccount.manage.legalAccountsListDescription") }}
      </p>
      <v-progress-circular
        class="d-flex align-center justify-center"
        v-if="isLoading"
        style="min-height: 200px;margin: 0 auto"
        color="primary"
        indeterminate
      />

      <div
        v-for="(item, index) in AccountsList"
        :key="index"
        @click="goLegalPage(item)"
        class="full-width d-flex flex-column flex-sm-row align-center justify-space-between px-6 py-3 gray7 rounded-lg mb-4 cursor-pointer"
      >
        <div class="d-flex align-center w-100">
          <img
            src="@/assets/image/legal/company-icon.svg"
            alt=""
            width="40"
            height="40"
          />
          <div class="ms-4">
            <span class="font-Regular-18">
              {{ item.name }}
            </span>
          </div>
        </div>

        <div
          class="info-status text-center"
          style="width: 200px;"
          :class="{
            'success-status': item.status.title === 'VERIFIED',
            'error-status':
              item.status.title === 'CANCELED' ||
              item.status.title === 'REJECTED' ||
              item.status.title === 'BLOCKED'
          }"
        >
          {{ item.status.locale }}
        </div>
        <!--        <v-icon-->
        <!--          :class="{ 'transfor-x': !$vuetify.rtl }"-->
        <!--          clr="var(&#45;&#45;v-gray3-base)"-->
        <!--        >-->
        <!--          $arrowLeft-->
        <!--        </v-icon>-->
      </div>
      <!-- <p class="gray3--text text-center font-Regular-16">هنوز حساب حقوقی ایجاد نکرده اید</p> -->
    </div>
  </v-card>
</template>

<style lang="scss"></style>
<script>
import legalService from "@/services/modules/legalService";
import { mapActions } from "vuex";
import * as types from "@/store/types";

export default {
  data() {
    return {
      AccountsList: [],
      isLoading: false
    };
  },
  mounted() {
    this.getAccountList();
  },

  methods: {
    ...mapActions({
      setAccountsList: types.corporate.actions.SET_ACCOUNTS_LIST
    }),

    goLegalPage(item) {
      const { uuid, status } = item;
      // if (status.title === "SUBMIT_REGISTRATION") {
      //   this.setLegalCookie(uuid);
      //   this.$router.push("/dashboard");
      // }
      if (status.title === "REJECTED") {
        this.$router.push({
          path: "/legal-entity/manage/create",
          query: { step: 1, CA_ID: uuid }
        });
      }
      if (status.title === "VERIFIED") {
        this.setLegalCookie(uuid);
        window.location.href = "/panel/dashboard";
      }
      if (status.title === "INITIALIZED") {
        this.$router.push({
          path: "/legal-entity/manage/create",
          query: { step: 2, CA_ID: uuid }
        });
      }
      if (status.title === "NEED_MEMBER_ACCEPTANCE") {
        this.$router.push({
          path: "/legal-entity/manage/signs-list",
          query: { CA_ID: uuid }
        });
      }
    },
    setLegalCookie(uuid) {
      this.$cookies.set("isLegal", true);
      this.$cookies.set("CA_ID", uuid);
      this.$cookies.set("showAlert", "true");
    },
    getAccountList() {
      this.isLoading = true;
      legalService
        .getAccountsList()
        .then(response => {
          this.AccountsList = response.data.data;
          this.setAccountsList(response.data.data);
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  }
};
</script>
